import { render, staticRenderFns } from "./TaskStatusName.vue?vue&type=template&id=42a13a88&scoped=true&"
import script from "./TaskStatusName.vue?vue&type=script&lang=js&"
export * from "./TaskStatusName.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusName.vue?vue&type=style&index=0&id=42a13a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a13a88",
  null
  
)

export default component.exports